import "regenerator-runtime";
import debug from "debug";
import ally from 'ally';

import "./components";
import "./vendor";

import * as tabmenu from '../core/components/tabmenu';
import * as menu from '../core/components/menu';
import * as lottieAnimation from '../core/components/lottieAnimation';
import * as firebase from '../core/components/firebase';

const log = debug('fusion-core');

var focusSource = ally.style.focusSource();

window.resetFocus = function() {
    console.log("resetting focus to document");
    document.activeElement.blur();
};

window.SetFocusToElement = function (elementId) {
    var element = document.getElementById(elementId);
    if (element != null) {
        element.focus();
    }
};

window.SetLoadingAnimation = function (elementId) {
    var loadingAnimationContainer = document.getElementById('loadingAnimationContainer');
    if(loadingAnimationContainer){
        var loadingAnimation = loadingAnimationContainer.children[0];
        if(loadingAnimation){
            lottie.applyToElement(loadingAnimation);
        }
    }
};

window.ScrollToId = function (id) {
    const element = document.getElementById(id);
        if (element instanceof HTMLElement) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
            element.focus();
        }
};

window.ScrollToIdIfNeeded = function (id) {
    const element = document.getElementById(id);
        if (element instanceof HTMLElement) {
            if(element.scrollIntoViewIfNeeded){
                element.scrollIntoViewIfNeeded(false);
                element.focus();
            }
        }
};

window.ScrollToTop = function (id) {    
    window.scrollTo({top: 0, behavior: 'smooth'});
};

window.getAddClaimImageHeight = function () {

    // access DOM here
    var div = document.getElementById("add-claim-img-c");
    return div.offsetWidth / 2 + "px";
};

window.moveCursorToEnd = function (id) {
    var input = document.getElementById(id);
    input.focus();
    var s = input.value;
    if (s.length) {
        window.setTimeout(function () {
            input.setSelectionRange(s.length, s.length);
        }, 0);
    }
};

window.openDatePicker = function (datePickerId) {
    var dateInput = document.getElementById(datePickerId);
    dateInput.show();
};

window.goBack = function () {
    window.history.back();
};

window.goBackMany = function (delta) {
    window.history.go(delta);
};

window.loadIframe = function (bytesBase64) {
    var iframe = document.createElement('iframe');
    iframe.style.width = "100%";
    iframe.style.height = "780px";
    iframe.src = "data:application/pdf;base64," + bytesBase64;
    document.getElementById("content").appendChild(iframe);
    document.getElementById("display-pdf").remove();
};

window.saveAsFile = function (filename, bytesBase64) {
    var link = document.createElement('a');
    link.download = filename;
    link.href = "data:application/octet-stream;base64," + bytesBase64;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

window.initialiseDatePicker = function (dotNetHelper, datePickerId) {
    console.log(dotNetHelper, datePickerId);
    window.customElements.whenDefined("duet-date-picker").then(() => {
        var datePicker = document.getElementById(datePickerId);
        if (datePicker) {
            datePicker.addEventListener("duetChange", function (event) {
                console.log(event.detail);
                dotNetHelper.invokeMethodAsync('UpdateDateValue', datePicker.value);
            });
        }
    });
};

window.getRadioValue = function (radioName) {
    var selectedRadio = document.querySelector('input[name="' + radioName + '"]:checked');
    if(selectedRadio != null){
        return selectedRadio.value;
    }
    else{
        return null;
    }
};

window.setRadioChecked = function (id) {
    var selectedRadio = document.querySelector('input[id="' + id + '"]');
    if(selectedRadio != null){
        selectedRadio.checked = true;
    }
    
};

window.setRadioButtonItemWidths = function () {
    let maxWidth = 110;
    var radioItems = document.querySelectorAll('.radio-field-label');
    var radioContainer = document.querySelector('.radio-question__answers');
    // find max width based on content
    radioItems.forEach((item) => {
        const width = item.offsetWidth;
        if (width > maxWidth) {
            maxWidth = width;
        }
    });

    // apply max width to all items
    radioItems.forEach((item) => {
        item.style.width = `${maxWidth}px`;
    });

    radioContainer.style.gridTemplateColumns = `repeat(auto-fill, ${maxWidth}px)`;
};

window.logEvent = function(name, params) {
    firebase.doLogEvent(name, params);
};

window.CustomClickListener = {};
window.addClickListener = function (dotNetHelper, scopeSelector, elementsSelector, methodIdentifier) {
    var scopeEl = document.querySelector(scopeSelector);
    if(!scopeEl) {
        return;
    }

    var listenerKey = `${scopeSelector}_${methodIdentifier}`;
    var elements = scopeEl.querySelectorAll(elementsSelector);

    // we don't want to double up on event handling, so remove any existing custom click handler
    if(typeof window.CustomClickListener[listenerKey] === 'function') {
        elements.forEach( el => {
            el.removeEventListener('click', window.CustomClickListener[listenerKey]);
            window.CustomClickListener[listenerKey] = undefined;
        });
    }

    window.CustomClickListener[listenerKey] = function(e) {
        e.preventDefault();
        e.stopPropagation();
        dotNetHelper.invokeMethodAsync(methodIdentifier);
    };

    elements.forEach( el => {
        el.addEventListener('click', window.CustomClickListener[listenerKey]);
    });
};

window.ScrollRight = function (Element, dotNetHelper) {
    if (document.getElementById(Element)) {
        var scrollView = document.getElementById(Element);

        if (document.getElementById('cover-card-id')) {

            var screenWidth = scrollView.offsetWidth;

            var scrollViewWidth = scrollView.scrollWidth;
            var scrollLeftWidth = scrollView.scrollLeft;
            var remainingWidth = scrollViewWidth - screenWidth - scrollLeftWidth;
            var contentWidth = document.getElementById('cover-card-id').scrollWidth;

            if(remainingWidth > contentWidth){
                scrollView.scrollBy({
                top: 0, left: contentWidth + 10, behavior: "smooth"
                });
            }else{
                var widthToScroll = contentWidth - remainingWidth;
                scrollView.scrollBy({
                top: 0, left: remainingWidth, behavior: "smooth"
                });
                dotNetHelper.invokeMethodAsync('IsScrollViewReachRightEnd', true);

            }            
        }
    }    
};

window.ScrollLeft = function (Element, dotNetHelper) {
    if (document.getElementById(Element)) {
        if (document.getElementById('cover-card-id')) {
            var scrollView = document.getElementById(Element);
            var contentWidth = document.getElementById('cover-card-id').offsetWidth;
            var scrollLeftWidth = scrollView.scrollLeft;
            if(scrollLeftWidth > contentWidth){
                document.getElementById(Element).scrollBy({
                top: 0, left: -document.getElementById('cover-card-id').offsetWidth - 10, behavior: "smooth"
            });
            }else{
                document.getElementById(Element).scrollBy({
                top: 0, left: -scrollLeftWidth, behavior: "smooth"
            });
            dotNetHelper.invokeMethodAsync('IsScrollViewReachLeftEnd', true);

            }

            
        }
    }
};

window.HorizontalScrollJSHelper = function (dotNetHelper) {

    if (document.getElementById("horizontal_container_scroll")) {
        var el = document.getElementById("horizontal_container_scroll");
        if (Math.abs(el.scrollLeft) === el.scrollWidth - el.clientWidth) {
            dotNetHelper.invokeMethodAsync('IsScrollViewReachRightEnd', true);
        } else {
            dotNetHelper.invokeMethodAsync('IsScrollViewReachRightEnd', false);
        }

        if (el.scrollLeft <= 0) {
            dotNetHelper.invokeMethodAsync('IsScrollViewReachLeftEnd', true);
        } else {
            dotNetHelper.invokeMethodAsync('IsScrollViewReachLeftEnd', false);

        }
    }
};

window.GetHeightByElementId = function (Element, Width) {
    if (document.getElementById(Element)) {
        return document.getElementById(Element).offsetHeight;
    }
};

window.setModalPopUpPageAndIntercept = (containerId, html) => {
    const container = document.getElementById(containerId);
    container.innerHTML = html;

    container.querySelectorAll("a[href]").forEach(a => {
        a.addEventListener("click", function (e) {
            e.preventDefault(); // stop default navigation
            const href = a.getAttribute("href");

            DotNet.invokeMethodAsync("MobileHealthFund.Web", "ModalPopUpPageAndInterceptHandleLinkClickById", href);
        });
    });
};

window.tabmenu = tabmenu;
window.lottie = lottieAnimation;
window.menu = menu;




// WEBPACK FOOTER //
// ./project/client/src/core/index.js